import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BlazeButton from '@blaze-react/button';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { MdMenu, MdClose } from 'react-icons/md';
import { Link } from '@blaze-cms/nextjs-components';
import MenuContext from './MenuContext';
import BlazeLink from '../BlazeLink';
const Menu = ({
  children,
  collapse,
  openActiveSubmenus,
  modifier,
  mobileMenuModifier,
  mobileMenuChildrenModifier,
  mobileIconAlignment,
  mobileButtonModifier,
  hamburgerIconModifier,
  logoOnMobile,
  logoOnDesktop,
  logoOnMobileUrl,
  logoOnMobileAlt,
  logoOnMobileModifier,
  logoOnDesktopModifier,
  closeIconModifier
}) => {
  const router = useRouter();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  useEffect(() => {
    const handleRouteChange = () => setShowMobileMenu(false);
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router.events]);
  const shouldDisplayChildren = collapse ? showMobileMenu : true;
  const childModifiers = classnames({
    [mobileMenuChildrenModifier]: shouldDisplayChildren,
    [modifier]: !showMobileMenu
  });
  const isMobileMenuExpanded = showMobileMenu ? `${mobileMenuModifier}` : '';
  const menuWrapperClasses = classnames('menu--wrapper', {
    'menu--wrapper--mobile-open': showMobileMenu,
    'menu--wrapper--mobile-closed': collapse && !showMobileMenu
  });
  return /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: {
      showMobileMenu,
      openActiveSubmenus
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: menuWrapperClasses
  }, collapse && /*#__PURE__*/React.createElement("div", {
    className: "menu--mobile-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `flex w-screen z-50 justify-${mobileIconAlignment} ${isMobileMenuExpanded}`
  }, /*#__PURE__*/React.createElement(BlazeButton, {
    className: `menu--mobile-button ${mobileButtonModifier}`,
    onClick: () => setShowMobileMenu(!showMobileMenu),
    label: showMobileMenu ? 'Close mobile menu' : 'Open mobile menu'
  }, /*#__PURE__*/React.createElement("i", null, showMobileMenu ? /*#__PURE__*/React.createElement(MdClose, {
    className: closeIconModifier
  }) : /*#__PURE__*/React.createElement(MdMenu, {
    className: hamburgerIconModifier
  }))))), logoOnMobile && !showMobileMenu && /*#__PURE__*/React.createElement(Link, {
    href: "/",
    name: "mobile menu"
  }, /*#__PURE__*/React.createElement("img", {
    src: logoOnMobileUrl,
    alt: logoOnMobileAlt,
    className: logoOnMobileModifier
  })), /*#__PURE__*/React.createElement("div", {
    className: "menu--desktop-wrapper"
  }, /*#__PURE__*/React.createElement("ul", {
    className: childModifiers
  }, logoOnDesktop && /*#__PURE__*/React.createElement(BlazeLink, {
    href: "/",
    className: ""
  }, /*#__PURE__*/React.createElement("img", {
    src: logoOnMobileUrl,
    alt: logoOnMobileAlt,
    className: logoOnDesktopModifier
  })), children))));
};
Menu.propTypes = {
  collapse: PropTypes.bool.isRequired,
  openActiveSubmenus: PropTypes.bool.isRequired,
  logoOnMobile: PropTypes.bool.isRequired,
  logoOnDesktop: PropTypes.bool,
  logoOnMobileUrl: PropTypes.string,
  logoOnMobileAlt: PropTypes.string,
  logoOnMobileModifier: PropTypes.string,
  logoOnDesktopModifier: PropTypes.string,
  hamburgerIconModifier: PropTypes.string,
  closeIconModifier: PropTypes.string,
  mobileButtonModifier: PropTypes.string,
  mobileMenuModifier: PropTypes.string,
  mobileMenuChildrenModifier: PropTypes.string,
  modifier: PropTypes.string,
  mobileIconAlignment: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Menu.defaultProps = {
  logoOnDesktop: false,
  logoOnMobileUrl: '',
  logoOnMobileAlt: '',
  logoOnMobileModifier: '',
  logoOnDesktopModifier: '',
  hamburgerIconModifier: '',
  closeIconModifier: '',
  mobileButtonModifier: '',
  mobileIconAlignment: '',
  mobileMenuModifier: '',
  mobileMenuChildrenModifier: '',
  modifier: '',
  children: []
};
export default Menu;
//# sourceMappingURL=Menu.js.map